export default __webpack_public_path__ + "static/media/logout-icon-white.dd3ec41b.svg";